import { css as e } from "../stitches.config.es.js";
const i = {
  variant: {
    primary: {
      color: "$primary100main"
    },
    secondary: {
      color: "$lightBg100Main"
    },
    tertiary: {
      color: "$coreGreys70"
    },
    warning: {
      color: "$destructive100main"
    },
    success: {
      color: "$success100"
    },
    dark: {
      color: "$coreGreys100main"
    },
    highlight: {
      color: "$highlight100"
    }
  },
  fontSize: {
    xxsmall: {
      fontSize: "$xsmall10",
      lineHeight: "$7"
    },
    xsmall: {
      fontSize: "$xsmall",
      lineHeight: "$7"
    },
    small: {
      fontSize: "$small",
      lineHeight: "$7"
    },
    normal: {
      fontSize: "$semiMedium",
      lineHeight: "$7"
    },
    large: {
      fontSize: "$medium",
      lineHeight: "$6"
    },
    xlarge: {
      fontSize: "$medium15",
      lineHeight: "$6"
    },
    xxlarge: {
      fontSize: "$large18",
      lineHeight: "$6"
    }
  },
  align: {
    start: {
      textAlign: "start"
    },
    center: {
      textAlign: "center"
    },
    end: {
      textAlign: "end"
    }
  }
}, l = e({
  fontFamily: "$default",
  defaultVariants: {
    fontSize: "normal"
  },
  variants: i
});
export {
  l as textStyles,
  i as textVariants
};
//# sourceMappingURL=Text.styles.es.js.map
